<span class="font-medium" *ngIf="showHeader && data?.header && data?.header.length > 0">
  {{data.header}}
</span>
<p>
  {{data?.message}}
</p>
